import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import '../Work.css';
import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";





const WorkCareer = () => {
    const navigate = useNavigate();

    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-work-headings">
                <h1>Portfolio Process & Plan</h1>
                <p>Plan that I am trying to implement for this portfolio</p>

                
            </div>

            <div className="line"></div>

            <div className="content-work">
                <div className="content-work-career">
                    <div className="content-work-career-text">
                    {/* <img src={gif2}></img> */}
                        <h1>Low Fidelity</h1>
                        <p>I tried to sketch what I want to make for my portfolio and came up with the picture on the right, I asked feedback from Amer and he said that I could try and make this design for my portfolio.</p>
                        <p>I was given feedback that I could make a version of my self on the hompage and has a mouse tracking that could make this portfolio looks interesting</p>

                        <h1>Medium Fidelity</h1>
                        <p>I use figma to try and make a better quality of what my idea looks like for this portfolio</p>
                        <p>Click <a href="https://www.figma.com/design/mVHvgE6IiKme0QJOcErMA8/Untitled?node-id=0-1&t=kJNspBAFMFCypXNn-1">here</a> to check out my figma</p>
                    </div>

                    <div className="content-work-career-image">
                        <div className="content-work-career-image-prot">
                            <img src={lowprot1}></img>
                            <img src={lowprot2}></img>
                        </div>
                        <img src={figma}></img>
                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default WorkCareer;